export const initialNodes = [
  {
    id: '1',
    position: { x: 200, y: 10 },
    type: 'textUpdater',
    data: {
      value: '',
    },
  },
  {
    id: '2',
    position: { x: 10, y: 100 },
    type: 'textUpdater',
    data: {
      value: '',
    },
  },
  {
    id: '3',
    position: { x: 350, y: 100 },
    type: 'textUpdater',
    data: {
      value: '',
    },
  },
];
export const initialEdges = [
  {
    id: 'e1-2',
    source: '1',
    target: '2',
    style: { stroke: 'black' },
    markerEnd: { type: 'arrow', color: 'black' },
  },
  {
    id: 'e1-3',
    source: '1',
    target: '3',
    style: { stroke: 'black' },
    markerEnd: { type: 'arrow', color: 'black' },
  },
];
